import {setPointerPosition} from '../section.cds2-slider-with-tooltips/initTabs/setPointerPosition';

export const initTableTabs = () => {
	const tableTabs = document.querySelectorAll( 'section.cds2-table-tabs' );

	if ( !tableTabs.length )
	{
		return;
	}

	Array.from( tableTabs ).forEach( ( it ) => {
		const pointer = it.querySelector( 'li.pointer' );

		if ( !pointer )
		{
			return;
		}

		let currentLabel = it.querySelector( '.current' );
		let currentID = currentLabel.dataset.tabValue;
		let currentTable = document.querySelector( `[data-tab-id="${currentID}"]` );

		currentTable.classList.add( 'current' );

		setTimeout( () => {
			setPointerPosition( currentLabel, pointer );
		}, 100 );

		it.addEventListener( 'click', ( evt ) => {
			currentLabel.classList.remove( 'current' );
			currentLabel = evt.target;
			currentLabel.classList.add( 'current' );
			currentID = currentLabel.dataset.tabValue;
			setPointerPosition( currentLabel, pointer );
			currentTable.classList.remove( 'current' );
			currentTable = document.querySelector( `[data-tab-id="${currentID}"]` );
			currentTable.classList.add( 'current' );
		} );
	} );
};
